export default lang => {
  localStorage.setItem("language", lang);
};
